import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=3d77c1a2"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=3d77c1a2&prod&lang=css"
import style1 from "./BaseLayout.vue?vue&type=style&index=1&id=3d77c1a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports